import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './GloryCommunity.css';
import { fetchLatestPlaylistVideo } from '../../services/youtubeService';
import config from '../../config';

const GloryCommunity = () => {
  const [videoId, setVideoId] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let isMounted = true;
    const playlistId = process.env.REACT_APP_YT_GLORY_PLAYLIST_ID || (config && config.YT_GLORY_PLAYLIST_ID);

    const load = async () => {
      try {
        if (!playlistId) {
          setError('Playlist not configured');
          setLoading(false);
          return;
        }
        const latest = await fetchLatestPlaylistVideo(playlistId);
        if (isMounted) {
          if (latest && latest.videoId) {
            setVideoId(latest.videoId);
          } else {
            setError('No videos found');
          }
          setLoading(false);
        }
      } catch (e) {
        if (isMounted) {
          setError('Failed to load latest video');
          setLoading(false);
        }
      }
    };

    load();
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <section className="section-padding">
      <Container>
        <h1 className="section-title">Glory Community</h1>
        <p className="text-center mb-5">
          Connect with our faith community through regular online gatherings, prayer sessions, 
          and interactive discussions.
        </p>
        
        <Row className="justify-content-center">
          <Col lg={10} md={12}>
            <div className="video-container">
              {loading ? (
                <div className="video-frame" style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
                  <span>Loading latest video...</span>
                </div>
              ) : error ? (
                <div className="video-frame" style={{display:'flex',alignItems:'center',justifyContent:'center'}}>
                  <span>{error}</span>
                </div>
              ) : (
                <iframe
                  src={`https://www.youtube.com/embed/${videoId}`}
                  title="Glory Community Video"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="video-frame"
                ></iframe>
              )}
            </div>
          </Col>
        </Row>

        <Row className="justify-content-center mt-5">
          <Col lg={8} md={10} className="text-center">
              <h3 className="mb-4">Interested in joining or sitting in on a Zoom call?</h3>
              <Button 
                as={Link} 
                to="/stay-connected" 
                variant="primary" 
                size="lg"
                className="cta-button"
              >
                Connect With Us
              </Button>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default GloryCommunity; 